export enum Permission {
  CRT_WEBAPI_CLIENTE = "CRT_WEBAPI_CLIENTE",
  CRT_WEBAPI_APP = "CRT_WEBAPI_APP",
  CRT_WEBAPI = "CRT_WEBAPI",
  CRT_WEBAPI_AUTORIZADOR_CANCELAROPERACAOV2 = "CRT_WEBAPI_AUTORIZADOR_CANCELAROPERACAOV2",
  CRT_WEBAPI_AUTORIZADOR_REGISTRAROPERACAOV2 = "CRT_WEBAPI_AUTORIZADOR_REGISTRAROPERACAOV2",
  CRT_WEBAPI_CARTAO_CONSULTAR_COMPRAS = "CRT_WEBAPI_CARTAO_CONSULTAR_COMPRAS",
  CRT_WEBAPI_CARTAO_CONSULTAR_DADOS_GERAIS = "CRT_WEBAPI_CARTAO_CONSULTAR_DADOS_GERAIS",
  CRT_WEBAPI_CARTAO_CONSULTAR_PERFIL = "CRT_WEBAPI_CARTAO_CONSULTAR_PERFIL",
  CRT_WEBAPI_CLIENTE_CONSULTARPERFIL_PROPOSTAS = "CRT_WEBAPI_CLIENTE_CONSULTARPERFIL_PROPOSTAS",
  CRT_WEBAPI_COMUNS_CONSULTAR_TIPOS_DOCUMENTOS = "CRT_WEBAPI_COMUNS_CONSULTAR_TIPOS_DOCUMENTOS",
  CRT_WEBAPI_COMUNS_CONSULTARBANCOS = "CRT_WEBAPI_COMUNS_CONSULTARBANCOS",
  CRT_WEBAPI_COMUNS_CONSULTARENDERECO = "CRT_WEBAPI_COMUNS_CONSULTARENDERECO",
  CRT_WEBAPI_COMUNS_CONSULTARESTADOSCIVIS = "CRT_WEBAPI_COMUNS_CONSULTARESTADOSCIVIS",
  CRT_WEBAPI_COMUNS_CONSULTARPROFISSOES = "CRT_WEBAPI_COMUNS_CONSULTARPROFISSOES",
  CRT_WEBAPI_COMUNS_GERARTOKEN = "CRT_WEBAPI_COMUNS_GERARTOKEN",
  CRT_WEBAPI_PROPOSTA_DISPENSAR_TOKEN_ACEITE = "CRT_WEBAPI_PROPOSTA_DISPENSAR_TOKEN_ACEITE",
  CRT_WEBAPI_COMUNS_VALIDARTOKEN = "CRT_WEBAPI_COMUNS_VALIDARTOKEN",
  CRT_WEB_ATE_CON_FILA_ANALISE = "CRT_WEB_ATE_CON_FILA_ANALISE",
  CRT_WEB_ATE_CON_ITENS_ANALISE = "CRT_WEB_ATE_CON_ITENS_ANALISE",
  CRT_WEB_ATE_CON_FILA_ANALISE_EDT = "CRT_WEB_ATE_CON_FILA_ANALISE_EDT",
  CRT_WEB_ATE_CON_FILA_ANALISE_EFE = "CRT_WEB_ATE_CON_FILA_ANALISE_EFE",
  CRT_WEB_ATE_CON_FILA_ANALISE_MESA = "CRT_WEB_ATE_CON_FILA_ANALISE_MESA",
  CRT_WEB_ATE_CON_FILA_ANALISE_DOC = "CRT_WEB_ATE_CON_FILA_ANALISE_DOC",
  CRT_WEBAPI_CONSULTA_CEP = "CRT_WEBAPI_CONSULTA_CEP",
  CRT_WEBAPI_PROPOSTA_BUSCAR = "CRT_WEBAPI_PROPOSTA_BUSCAR",
  CRT_WEBAPI_PROPOSTA_CONSULTAR = "CRT_WEBAPI_PROPOSTA_CONSULTAR",
  CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTO = "CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTO",
  CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTOS_OBRIGATIOS = "CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTOS_OBRIGATIOS",
  CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTOS_OBRIGATORIOS = "CRT_WEBAPI_PROPOSTA_CONSULTAR_DOCUMENTOS_OBRIGATORIOS",
  CRT_WEBAPI_PROPOSTA_CONSULTARDOCUMENTOSOBRIGATORIOS = "CRT_WEBAPI_PROPOSTA_CONSULTARDOCUMENTOSOBRIGATORIOS",
  CRT_WEBAPI_PROPOSTA_UPLOAD_DOCUMENTO = "CRT_WEBAPI_PROPOSTA_UPLOAD_DOCUMENTO",
  CRT_WEBAPI_PROPOSTA_VALIDAR_FONE = "CRT_WEBAPI_PROPOSTA_VALIDAR_FONE",
  CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARDESTINOSDASFATURAS = "CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARDESTINOSDASFATURAS",
  CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARPRODUTOSDISPONIVEIS = "CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARPRODUTOSDISPONIVEIS",
  CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARTARIFASENVIOFATUROS = "CRT_WEBAPI_PROPOSTAMOBILE_CONSULTARTARIFASENVIOFATUROS",
  CRT_WEBAPI_PROPOSTAMOBILE_INCLUIRPROPOSTA = "CRT_WEBAPI_PROPOSTAMOBILE_INCLUIRPROPOSTA",
  CRT_WEBAPI_PROPOSTAMOBILE_SITUACAOCLIENTE = "CRT_WEBAPI_PROPOSTAMOBILE_SITUACAOCLIENTE",
  CRT_WEBAPI_TERMINAL = "CRT_WEBAPI_TERMINAL",
  CRT_WEBAPI_TERMINAL_CANCELAR_TRANSACAO = "CRT_WEBAPI_TERMINAL_CANCELAR_TRANSACAO",
  CRT_WEBAPI_TERMINAL_PAGAMENTO = "CRT_WEBAPI_TERMINAL_PAGAMENTO",
  DESENVOLVIMENTO = "DESENVOLVIMENTO"
}

export enum PermissionsRoles {
  GENERAL = "general",
  SALES = "sales",
  PROPOSALS = "proposals",
  CREDIT = "credit"
}

export const PermissionsGroup = {
  [PermissionsRoles.GENERAL]: [Permission.CRT_WEBAPI_CLIENTE],
  [PermissionsRoles.SALES]: [Permission.CRT_WEBAPI_TERMINAL],
  [PermissionsRoles.CREDIT]: [
    Permission.CRT_WEBAPI_CLIENTE,
    Permission.CRT_WEBAPI_AUTORIZADOR_CANCELAROPERACAOV2
  ]
};
